<template>
  <div class="confirm">
    <ul class="bread f-dpf">
      <li class="bread-it active">
        确认订单
        <i class="bread-ic"><span>1</span></i>
      </li>
      <li class="bread-it">
        支付
        <i class="bread-ic"><span>2</span></i>
      </li>
      <li class="bread-it">
        获取注册码
        <i class="bread-ic"><span>3</span></i>
      </li>
    </ul>
    <!-- v-if="hasProduct" -->
    <el-alert :title="errorTips" type="error" center :closable="false" v-if="!hasProduct" show-icon>
    </el-alert>
    <div class="mn-bx" v-if="hasProduct">
      <div class="order">
        <h3>购买商品信息</h3>

        <el-table
          v-if="windowWidth > 768"
          :data="productInfo"
          :span-method="arraySpanMethod"
          style="width: 100%"
          class="table"
          v-loading="tableLoading"
        >
          <el-table-column prop="soft_name" label="商品名称" min-width="140px"> </el-table-column>
          <el-table-column prop="version" label="商品版本" min-width="140px"></el-table-column>
          <el-table-column prop="price" label="商品单价" min-width="100px">
            <template slot-scope="scope">{{ "￥" + scope.row.price }}</template>
          </el-table-column>
          <el-table-column label="商品数量" prop="number" min-width="100px">
            <!-- <template slot-scope="scope">
               
                <el-input-number size="mini" v-model="scope.row.num" @change="handleChange(scope)" :min="1" label="描述文字"></el-input-number>
              </template> -->
          </el-table-column>
          <el-table-column prop="total_price" label="总价" min-width="100px">
            <template slot-scope="scope">{{ "￥" + scope.row.total_price }}</template>
          </el-table-column>
        </el-table>

        <div v-loading="tableLoading" class="phone-table" v-else style="margin-bottom: 30px">
          <el-row v-for="(item, index) in productInfo" :key="index" class="vertical-table">
            <el-col :span="24">
              <div class="text item"><strong>商品名称:</strong> {{ item.soft_name }}</div>
              <div class="text item"><strong>商品版本:</strong> {{ item.version }}</div>
              <div class="text item"><strong>商品单价:</strong> ￥{{ item.price }}</div>
              <div class="text item"><strong>商品数量:</strong> {{ item.number }}</div>
              <div class="text item"><strong>总价:</strong> ￥{{ item.total_price }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- <Form ref="rulesForm" :model="rulesForm" :rules="rules"> -->
      <div class="user">
        <h3>购买用户信息</h3>
        <el-form ref="rulesForm" :model="rulesForm" :rules="rules">
          <div class="basics">
            <el-form-item label="姓名:" prop="username">
              <el-input v-model="rulesForm.username" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机:" prop="tel">
              <el-input v-model="rulesForm.tel" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="邮箱:" prop="email" style="margin-bottom: 0">
              <el-input v-model="rulesForm.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
          </div>

          <!-- <div class="radio-bx">
              <h3>支付方式</h3>
              <el-form-item label="" prop="payType" style="width: 100%">
                <el-radio v-model="payType" label="2">微信支付</el-radio>
                <el-radio v-model="payType" label="1">支付宝支付</el-radio>
                <el-radio v-model="payType" label="3">对公转账</el-radio>
              </el-form-item>
              <p class="s-fc-danger">
                *支付完成后进行开票，开票信息填写再【获取注册码】页面得下方
              </p>
            </div> -->

          <el-form-item class="f-tac f-submit">
            <el-button
              :loading="btnLoading"
              class="btn-org btn"
              type="primary"
              @click="handleSubmit('rulesForm')"
              >提交订单</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- </Form> -->
    </div>

    <div class="contact">
      <h3 class="f-tac">联系我们</h3>
      <div class="g-cnt f-dpf">
        <div class="img-bx">
          <img
            src="https://www.abackup.com/assets/images/icon/wx_dl.png"
            width="180"
            height="180"
            alt=""
          />
        </div>
        <div class="txt-bx">
          <h4>微信扫一扫，联系我们工作人员</h4>
          <p>联系电话：028-61533037</p>
          <p>联系邮件：aomeitech@163.com</p>
          <p>联系地址：四川省成都市锦江区下沙河铺街59号(联合广场)1栋2单元6层</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
// @ is an alias to /src
import windowWidthMixin from "@/mixins/windowWidthMixin";
// import { apiOrders } from '../api/api'
import * as api from "../api/api";
export default {
  name: "ConfirmOrder",
  components: {},
  mixins: [windowWidthMixin],
  data() {
    return {
      tableLoading: true,
      btnLoading: false,
      hasProduct: true,
      errorTips: "没有产品号或者数量",
      rulesForm: {
        username: "",
        tel: "",
        email: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 1, max: 24, message: "长度不得大于24", trigger: "blur" }
        ],
        tel: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
            message: "请输入合法手机号/电话号",
            trigger: "blur"
          }
        ],
        email: [
          {
            type: "email",
            required: true,
            message: "请输入正确邮箱",
            trigger: "blur"
          }
        ]
      },
      payType: "2",
      productOverview: {
        productId: this.$route.query.productId,
        productNum: parseInt(this.$route.query.productNum),
        fristPathName: decodeURI(this.$route.query.first) || "",
        currentPathName: decodeURI(this.$route.query.current) || ""
      },
      productInfo: [
        {
          // name: "",
          // edition: "",
          // unitPrice: "",
          // num: 0,
          // totalPrice: 0,
          // skuId: 0,
        }
      ]
    };
  },
  methods: {
    ...mapMutations(["delOrderNumberList", "delPayType"]),
    //请求渲染产品信息
    getProduct() {
      // productInfo
      let productOverview = this.productOverview;
      let productId = productOverview.productId;
      let productNum = productOverview.productNum;
      if (!(productId || productNum)) {
        this.hasProduct = false;
      }

      productId &&
        productNum &&
        api.productInfo(productId).then((resp) => {
          console.log(resp);
          this.tableLoading = false;
          resp = resp.data;
          this.productInfo = resp.softs;
          this.productInfo.forEach(function(currentValue) {
            currentValue.total_price = resp.total_price;
            currentValue.number = productOverview.productNum; //购买份数
            console.log(currentValue, "currentValue");
          });
          console.log(this.productInfo, "productInfo");
        });
    },
    // 产品信息表格合并列
    arraySpanMethod({ columnIndex }) {
      if (columnIndex === 4) {
        return {
          rowspan: 2,
          colspan: 1
        };
      }
    },
    ...mapMutations(["updateEmail", "setPayType", "setUser", "setOrderNumberList"]),
    //提交用户表单
    handleSubmit(formName) {
      let obj = {
        soft_sku_id: this.productOverview.productId,
        quantity: this.productOverview.productNum,
        nickname: this.rulesForm.username,
        mobile: this.rulesForm.tel,
        email: this.rulesForm.email,
        landing_page: this.productOverview.fristPathName,
        purchase_page: this.productOverview.currentPathName,
        pay_method: this.payType
      };

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          api
            .orders(obj)
            .then((resp) => {
              console.log(resp);

              // return true;
              if (resp.code == 200) {
                // this.updateEmail(this.rulesForm.email); //储存用户邮箱
                this.setPayType(resp.data);
                this.setOrderNumberList(resp.data.out_trade_no); // 储存订单号
                console.log(resp.data, "777777777777777777订单");
                this.setUser(obj); //储存用户信息
                this.$router.push("/pay");
              } else {
                this.$message({
                  showClose: true,
                  message: resp.msg,
                  type: "error"
                });
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        } else {
          //验证不通过，定位到第一个非法位置
          setTimeout(() => {
            let isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);
          return false;
        }
      });
    },
    handleChange(scope) {
      scope.row.totalPrice = scope.row.num * scope.row.unitPrice;
    }
  },
  computed: {},
  created() {
    this.getProduct();
    this.delOrderNumberList();
    this.delPayType();
  }
};
</script>

<style lang="less">
h3 {
  margin-bottom: 30px;
}

.user .btn-org {
  height: 60px;
  width: 240px;
  font-size: 24px;
}

.basics {
  background: #eee;
  padding: 50px;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 80px;
  .el-form-item__label {
    font-size: 18px;
  }
  .el-form-item__content {
    display: inline-block;
    width: 280px;
  }
  .el-form-item {
    display: inline-block;
    margin-bottom: 40px;
    .el-input {
      max-width: 280px;
      height: 40px;
    }
  }
}
@media (min-width: 1200px) {
  .basics {
    padding-left: 120px;
    padding-right: 120px;
  }
}
@media (max-width: 822px) {
  .basics {
    padding: 20px 20px 30px;
    margin-bottom: 30px;
    .el-form-item__content {
      width: calc(100% - 70px);
    }
    .el-form-item,
    .el-form-item .el-input {
      width: 100%;
      max-width: 100%;
    }
    .el-form-item {
      margin-bottom: 24px;
    }
  }
}
</style>

<style lang="less" scoped>
.table {
  margin-bottom: 80px;
}
/deep/ .el-table .cell {
  word-break: inherit !important;
}
/deep/ .el-form-item__label {
  font-size: 16px;
}
</style>
